import React from 'react';

const ShopContext = React.createContext({
  shop: {},
  delivery_data: {},
  setShop: (data) => {},
  setDeliveryData: (data) => {},
});

export default ShopContext;
